import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=1f48031e&scoped=true&"
import script from "./ReminderList.vue?vue&type=script&lang=js&"
export * from "./ReminderList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderList.vue?vue&type=style&index=0&id=1f48031e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48031e",
  null
  
)

export default component.exports